import { Navigate, useParams } from 'react-router-dom';
import { GuideContainer } from '../container/GuideContainer';

export function GuidanceTourPage() {
  const { salesIndividualId } = useParams();

  if (!salesIndividualId) {
    return <Navigate to="/guidance" />;
  }

  return <GuideContainer salesIndividualId={salesIndividualId} />;
}
